export default class KameleoonQueue {
  constructor() {
    window.kameleoonQueue = window.kameleoonQueue || [];
  }

  public pushGoal(goal: string): void {
    window.kameleoonQueue.push(() => {
      // eslint-disable-next-line no-use-before-define
      if (typeof Kameleoon !== 'undefined') {
        // eslint-disable-next-line no-use-before-define
        Kameleoon.API.Goals.processConversion(goal);
      }
    });
  }

  public pushGoalWithRevenue(goal: string, revenue: number): void {
    window.kameleoonQueue.push(() => {
      // eslint-disable-next-line no-use-before-define
      if (typeof Kameleoon !== 'undefined') {
        // eslint-disable-next-line no-use-before-define
        Kameleoon.API.Goals.processConversion(goal, revenue);
      }
    });
  }

  public pushCustomData(key: string, value: string): void {
    window.kameleoonQueue.push(() => {
      // eslint-disable-next-line no-use-before-define
      if (typeof Kameleoon !== 'undefined') {
        // eslint-disable-next-line no-use-before-define
        Kameleoon.API.Data.setCustomData(key, value);
      }
    });
  }
}

declare global {
  interface Window {
    kameleoonQueue: Array<() => void>;
  }
}

declare const Kameleoon: {
  API: {
    Data: {
      setCustomData(key: string, value: string): void;
    };
    Goals: {
      processConversion(goalId: string, revenue?: number): void;
    };
  };
};
